/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\PasswordForgotten\PasswordForgotten.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Friday August 4th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 1st February 2024 12:11:02
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useLang } from "Router/LangueProvider";
import { useEffect, useState, MouseEvent } from "react";
import {Form, Button, Col} from 'react-bootstrap';
import Styles from "Content/Password/PasswordForgotten/PasswordForgotten.module.css";
import BackArrow from "Content/BackArrow/BackArrow";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import UserService from "Services/Users/UserService";
import { useNavigate } from "react-router-dom";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";

function PasswordForgotten() {
    const {translator} = useLang();
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);

    useEffect(() => {
        const userNameStocked = localStorage.getItem("userName");
        if (userNameStocked) {
            setUserName(userNameStocked);
            localStorage.removeItem("userName");
        }
    }, []);

    const HandleSubmit = async (e: any) => {
        e.preventDefault();
        try {
            const myRet = await UserService.forgottenPassword(userName);
            setIsOkay(true);
            setOpenModal(true);
        } catch (error) {
            setOpenModal(true);
        }
    };

    const handleToggleModal = (event: MouseEvent<HTMLElement>) => {
        setIsOkay(false);
        setOpenModal(false);
        navigate(RouterPathResolver.pathLogin.path);
    };

    return (
        <>
            <div className={`${Styles.forgotPassword}`}>
                <img loading="lazy" className={`${Styles.backgroundImg}`} src="/assets/parking.png" alt={translator.decode("image.background")} />
                <Form className={`flex-column ${Styles.form}`} onSubmit={HandleSubmit}>
                    <div className={`${Styles.headingForm}`}>
                        <div className={`${Styles.backArrow}`}>
                            <BackArrow />
                        </div>
                        <img loading="lazy" className={`${Styles.logo}`} src="/minimal_logo.png" alt={translator.decode("image.logo")} />
                    </div>
                    <Form.Group className="flex-column mb-3" controlId="formPlaintextEmail">
                        <Form.Label>
                            {translator.decode("login.placeholder.username")}
                        </Form.Label>
                        <Col>
                            <Form.Control autoFocus type="email" placeholder="example@mail.com" value={userName} onChange={(e) => setUserName(e.target.value)} required/>
                        </Col>
                    </Form.Group>
                    <Button title="Login" type="submit">{translator.decode("dynamic.send")}</Button>
                </Form>
            </div>
            <ModalConfirmation show={openModal} onClose={handleToggleModal} closeModal={handleToggleModal} customText={translator.decode("login.resetPassword")} isOkay={isOkay} themeColor={""} />
        </>
    )
}

export default PasswordForgotten;
